import * as Yup from 'yup'
import { getInitialState } from '../../../utils/formikUpdate'
import { fetchAllCantones } from '../../../services/cantonService'

/**
 * Valida que un string sea un GeoJSON válido
 */
const isValidGeoJSON = value => {
  if (!value) return true // Es opcional
  try {
    const parsed = typeof value === 'string' ? JSON.parse(value) : value
    const validTypes = ['FeatureCollection', 'Feature', 'Polygon', 'MultiPolygon', 'Point', 'LineString', 'MultiPoint', 'MultiLineString', 'GeometryCollection']
    return parsed && validTypes.includes(parsed.type)
  } catch {
    return false
  }
}

export const datasetFormik = async () => {
  // Obtener cantones para el select
  let cantonesOptions = {}
  let cantonesData = []
  try {
    const cantones = await fetchAllCantones()
    cantonesData = cantones
    cantones.forEach(c => {
      cantonesOptions[c.id] = c.name || c.nombre
    })
  } catch (err) {
    console.error('Error loading cantones:', err)
  }

  // === PASO 1: INFORMACIÓN BÁSICA ===
  const STEP1_FIELDS = [
    {
      x: 12,
      name: 'nombre',
      initvalue: '',
      label: 'Nombre de la Parroquia *',
    },
    {
      x: 6,
      name: 'slug',
      initvalue: '',
      label: 'Slug (URL) *',
    },
    {
      x: 6,
      name: 'id_canton',
      initvalue: '',
      label: 'Cantón *',
      options: cantonesOptions,
    },
    {
      x: 6,
      name: 'tipo',
      initvalue: 'urbana',
      label: 'Tipo de Parroquia',
      options: { urbana: 'Urbana', rural: 'Rural' },
    },
    {
      x: 6,
      name: 'habilitado',
      initvalue: 1,
      label: 'Estado',
      options: { 0: 'Desactivado', 1: 'Activado' },
    },
  ]

  // === PASO 2: BOUNDARY GEOJSON ===
  const STEP2_FIELDS = [
    {
      x: 12,
      name: 'boundary_geojson',
      initvalue: '',
      label: 'Boundary GeoJSON',
      isGeoJSONInput: true,
    },
  ]

  // === PASO 3: CONFIGURACIÓN DE CENTROIDE ===
  const STEP3_FIELDS = [
    {
      x: 6,
      name: 'center_lng',
      initvalue: '',
      label: 'Longitud (Centro)',
      helperText: 'Opcional - se calcula automáticamente',
      type: 'number',
    },
    {
      x: 6,
      name: 'center_lat',
      initvalue: '',
      label: 'Latitud (Centro)',
      helperText: 'Opcional - se calcula automáticamente',
      type: 'number',
    },
  ]

  // Todos los campos combinados
  const ITEMS_PARROQUIA_FORMIK = [...STEP1_FIELDS, ...STEP2_FIELDS, ...STEP3_FIELDS]

  const INITIAL_FORMIK_STATE = getInitialState(ITEMS_PARROQUIA_FORMIK)

  // Validaciones por paso
  const STEP1_VALIDATION = Yup.object().shape({
    nombre: Yup.string()
      .min(3, 'Mínimo 3 caracteres')
      .max(100, 'Máximo 100 caracteres')
      .required('Obligatorio'),
    slug: Yup.string()
      .min(2, 'Mínimo 2 caracteres')
      .max(50, 'Máximo 50 caracteres')
      .matches(/^[a-z0-9-]+$/, 'Solo letras minúsculas, números y guiones')
      .required('Obligatorio'),
    id_canton: Yup.number()
      .required('Obligatorio')
      .typeError('Seleccione un cantón'),
    tipo: Yup.string()
      .oneOf(['urbana', 'rural'], 'Tipo inválido')
      .nullable(),
  })

  const STEP2_VALIDATION = Yup.object().shape({
    boundary_geojson: Yup.string()
      .test('is-valid-geojson', 'Debe ser un GeoJSON válido', isValidGeoJSON)
      .nullable()
      .transform((value, originalValue) => (originalValue === '' ? null : value)),
  })

  const STEP3_VALIDATION = Yup.object().shape({
    center_lng: Yup.number()
      .min(-180, 'Longitud mínima -180')
      .max(180, 'Longitud máxima 180')
      .nullable()
      .transform((value, originalValue) => originalValue === '' ? null : value)
      .typeError('Debe ser un número'),
    center_lat: Yup.number()
      .min(-90, 'Latitud mínima -90')
      .max(90, 'Latitud máxima 90')
      .nullable()
      .transform((value, originalValue) => originalValue === '' ? null : value)
      .typeError('Debe ser un número'),
  })

  const FORM_VALIDATION = STEP1_VALIDATION
    .concat(STEP2_VALIDATION)
    .concat(STEP3_VALIDATION)

  return {
    INITIAL_FORMIK_STATE,
    ITEMS_PARROQUIA_FORMIK,
    STEP1_FIELDS,
    STEP2_FIELDS,
    STEP3_FIELDS,
    STEP1_VALIDATION,
    STEP2_VALIDATION,
    STEP3_VALIDATION,
    FORM_VALIDATION,
    cantonesData,
  }
}
